export { default as WhitepaperLink } from './component';
